import HttpClienteToken from '../../services/HttpClientToken';

import { AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';

export const Autoridades = () => {

    return new Promise<AutoridadProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Autoridad/', token)
            .then( ({ data } : { data : AutoridadProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerAutoridades = () => {

    return new Promise<AutoridadProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Autoridad/ObtenerAutoridades/', token)
            .then( ({ data } : { data : AutoridadProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarAutoridad = ( params: AutoridadProps ) => {

    return new Promise<AutoridadProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Autoridad/Actualizar', params, token)
            .then( ({ data } : { data : AutoridadProps } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAutoridad: 0, 
                    referencia: 0,
                    descripcion: '',                 
                    idMateria: 0,
                    idDistritoJudicial: 0,
                    activo: false,
                });
            });
        }

    });

}

export const AgregarAutoridad = ( params: AutoridadProps ) => {

    return new Promise<AutoridadProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Autoridad/Agregar', params, token)
            .then( ({ data } : { data : AutoridadProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAutoridad: 0,
                    descripcion: '',
                    idMateria: 0,
                    idDistritoJudicial: 0,
                    activo: false,
                });
            });
        }

    });

}
